"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadFile = downloadFile;

/**
 * Download file.
 *
 * @param {Blob} blob
 * @param {string} filename
 */
function downloadFile(blob, filename) {
  var link = document.createElement('a');
  document.body.appendChild(link);
  var url = window.URL.createObjectURL(blob);
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
}